import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MasterData } from '../../models/item/master-data';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class MasterDataProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/master-data';

  searchMasterData(code: string): Observable<ApiResponse<MasterData>> {
    return this.httpClient.post<ApiResponse<MasterData>>(`${this.baseUrl}/search`, { code });
  }
}
